import { useState } from "react";
import { Download, Search, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const fmt = (iso) => new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });

export default function LeadsTable({ leads, onSearch, onDelete, call }) {
  const [q, setQ] = useState("");

  const exportCsv = async () => {
    let blob;
    try {
      blob = await call("get", "/admin/leads.csv", null, { responseType: "blob" });
    } catch {
      return toast.error("Esportazione non riuscita");
    }
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "iscritte-guida.csv";
    a.click();
    URL.revokeObjectURL(url);
    toast.success("CSV scaricato");
  };

  return (
    <div className="bg-white border border-[#E5E1D8] rounded-2xl p-4 sm:p-5" data-testid="leads-table-card">
      <div className="flex flex-col sm:flex-row gap-3 sm:items-center justify-between mb-4">
        <form onSubmit={(e) => { e.preventDefault(); onSearch(q); }} className="relative w-full sm:max-w-xs">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#5A625C]" />
          <Input data-testid="leads-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca email…" className="pl-9" />
        </form>
        <Button data-testid="leads-export-csv-button" onClick={exportCsv} variant="outline" className="gap-2">
          <Download className="w-4 h-4" /> Esporta CSV
        </Button>
      </div>
      <div className="overflow-x-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Nome</TableHead>
              <TableHead>Email</TableHead>
              <TableHead className="hidden sm:table-cell">Iscritta il</TableHead>
              <TableHead>Email inviate</TableHead>
              <TableHead />
            </TableRow>
          </TableHeader>
          <TableBody>
            {leads.length === 0 && (
              <TableRow><TableCell colSpan={5} className="text-center text-[#5A625C] py-10" data-testid="leads-empty">Ancora nessuna iscritta. Condividi il link in bio!</TableCell></TableRow>
            )}
            {leads.map((l) => (
              <TableRow key={l.id} data-testid={`lead-row-${l.id}`}>
                <TableCell className="font-medium">{l.name || "—"}</TableCell>
                <TableCell>{l.email}</TableCell>
                <TableCell className="hidden sm:table-cell text-[#5A625C]">{fmt(l.created_at)}</TableCell>
                <TableCell>
                  {l.unsubscribed ? <Badge variant="outline">disiscritta</Badge> : <span>{l.emails_sent} / 4</span>}
                </TableCell>
                <TableCell className="text-right">
                  <Button size="icon" variant="ghost" aria-label="Elimina" data-testid={`lead-delete-${l.id}`} onClick={() => onDelete(l.id)}>
                    <Trash2 className="w-4 h-4 text-[#C05746]" />
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
